import "./App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";
import AppLayout from "./components/AppLayout";
import Login from "./pages/Login";
import GoogleCallback from "./pages/GoogleCallback";
import SuperAdmin from "./pages/SuperAdmin";
import Dashboard from "./pages/Dashboard";
import RawMaterials from "./pages/RawMaterials";
import Products from "./pages/Products";
import Production from "./pages/Production";
import Transfers from "./pages/Transfers";
import Invoices from "./pages/Invoices";
import PurchaseOrders from "./pages/PurchaseOrders";
import Expenses from "./pages/Expenses";
import Payments from "./pages/Payments";
import Contacts from "./pages/Contacts";
import Warehouses from "./pages/Warehouses";
import UsersPage from "./pages/Users";
import SettingsPage from "./pages/Settings";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";

function Protected({ children }) {
  const { user, checked } = useAuth();
  if (!checked || user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="font-mono text-sm text-muted-foreground animate-pulse">Loading…</div>
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (user.is_super_admin) return <Navigate to="/admin" replace />;
  return <AppLayout>{children}</AppLayout>;
}

function SuperProtected({ children }) {
  const { user, checked } = useAuth();
  if (!checked || user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="font-mono text-sm text-muted-foreground animate-pulse">Loading…</div>
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (!user.is_super_admin) return <Navigate to="/" replace />;
  return children;
}

function AppRoutes() {
  const location = useLocation();
  // Handle Google OAuth callback (session_id arrives in the URL fragment) BEFORE routing.
  if (location.hash && location.hash.includes("session_id=")) {
    return <GoogleCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/admin" element={<SuperProtected><SuperAdmin /></SuperProtected>} />
      <Route path="/" element={<Protected><Dashboard /></Protected>} />
      <Route path="/raw-materials" element={<Protected><RawMaterials /></Protected>} />
      <Route path="/products" element={<Protected><Products /></Protected>} />
      <Route path="/production" element={<Protected><Production /></Protected>} />
      <Route path="/transfers" element={<Protected><Transfers /></Protected>} />
      <Route path="/invoices" element={<Protected><Invoices /></Protected>} />
      <Route path="/purchase-orders" element={<Protected><PurchaseOrders /></Protected>} />
      <Route path="/expenses" element={<Protected><Expenses /></Protected>} />
      <Route path="/payments" element={<Protected><Payments /></Protected>} />
      <Route path="/contacts" element={<Protected><Contacts /></Protected>} />
      <Route path="/warehouses" element={<Protected><Warehouses /></Protected>} />
      <Route path="/users" element={<Protected><UsersPage /></Protected>} />
      <Route path="/settings" element={<Protected><SettingsPage /></Protected>} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
        <Toaster position="bottom-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
